import styled from '@emotion/styled';

export const HeadingInfoRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(3)};
  align-items: center;

  > span {
    ${({ theme }) => theme.text.body2};
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
    align-items: center;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const Divider = styled.div`
  height: ${({ theme }) => theme.spacing(4)};
  border-left: ${({ theme }) => theme.borderLight};
`;
